import React from "react";
import SMACDashboard from "./index";
import {VIEW_BY_USAGE} from "./constants";


export default function DashboardAcquisitionRegistrationInstance() {
    return <SMACDashboard title="SMAC Dashboard" tabBlackList={[VIEW_BY_USAGE]}/>
}